module.exports = __webpack_public_path__ + "static/media/facebook.f8b97394.svg";